"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgcpType = exports.rgcpPerformancePreviewList = exports.rgcpPanelPreviewList = exports.rgcpHtmlUpdate = exports.rgcpHtmlSuccess = exports.rgcpHtmlSoftDeletedList = exports.rgcpHtmlSoftDeleteRestore = exports.rgcpHtmlSoftDelete = exports.rgcpHtmlReset = exports.rgcpHtmlPreviewList = exports.rgcpHtmlList = exports.rgcpHtmlFetch = exports.rgcpHtmlError = exports.rgcpHtmlDelete = exports.rgcpHtmlDefaultHtmlList = exports.rgcpHtmlBulkSoftDelete = exports.rgcpHtmlBulkRestore = exports.rgcpHtmlBulkHardDelete = exports.rgcpHtmlAdd = void 0;
var _rgcpHtml = require("./rgcpHtml.constant");
// @flow

// common success
var rgcpHtmlSuccess = function rgcpHtmlSuccess(actionType, data) {
  return {
    type: _rgcpHtml.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.rgcpHtmlSuccess = rgcpHtmlSuccess;
var rgcpHtmlError = function rgcpHtmlError(actionType, error) {
  return {
    type: _rgcpHtml.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.rgcpHtmlError = rgcpHtmlError;
var rgcpHtmlFetch = function rgcpHtmlFetch(data) {
  return {
    type: _rgcpHtml.actionTypes.FETCH,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.rgcpHtmlFetch = rgcpHtmlFetch;
var rgcpHtmlPreviewList = function rgcpHtmlPreviewList(data) {
  return {
    type: _rgcpHtml.actionTypes.PREVIEW_LIST,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to rgcp get data.
 */
exports.rgcpHtmlPreviewList = rgcpHtmlPreviewList;
var rgcpPanelPreviewList = function rgcpPanelPreviewList(data) {
  return {
    type: _rgcpHtml.actionTypes.RGCP_PREVIEW,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to rgcp PERFORMANCE get data.
 */
exports.rgcpPanelPreviewList = rgcpPanelPreviewList;
var rgcpPerformancePreviewList = function rgcpPerformancePreviewList(data) {
  return {
    type: _rgcpHtml.actionTypes.RGCP_PERFORMANCE_PREVIEW,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.rgcpPerformancePreviewList = rgcpPerformancePreviewList;
var rgcpHtmlList = function rgcpHtmlList(data) {
  return {
    type: _rgcpHtml.actionTypes.LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.rgcpHtmlList = rgcpHtmlList;
var rgcpHtmlDefaultHtmlList = function rgcpHtmlDefaultHtmlList(data) {
  return {
    type: _rgcpHtml.actionTypes.DEFAULT_HTML_LIST,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.rgcpHtmlDefaultHtmlList = rgcpHtmlDefaultHtmlList;
var rgcpHtmlDelete = function rgcpHtmlDelete(data) {
  return {
    type: _rgcpHtml.actionTypes.DELETE,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.rgcpHtmlDelete = rgcpHtmlDelete;
var rgcpHtmlAdd = function rgcpHtmlAdd(data) {
  return {
    type: _rgcpHtml.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.rgcpHtmlAdd = rgcpHtmlAdd;
var rgcpHtmlUpdate = function rgcpHtmlUpdate(data) {
  return {
    type: _rgcpHtml.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * type
 * @param payload
 * @returns api response
 * @description this function used to get rgcp type data.
 */
exports.rgcpHtmlUpdate = rgcpHtmlUpdate;
var rgcpType = function rgcpType(data) {
  return {
    type: _rgcpHtml.actionTypes.TYPES,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset item.
 */
exports.rgcpType = rgcpType;
var rgcpHtmlReset = function rgcpHtmlReset() {
  return {
    type: _rgcpHtml.actionTypes.RESET
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete.
 */
exports.rgcpHtmlReset = rgcpHtmlReset;
var rgcpHtmlSoftDelete = function rgcpHtmlSoftDelete(data) {
  return {
    type: _rgcpHtml.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft delete restore.
 */
exports.rgcpHtmlSoftDelete = rgcpHtmlSoftDelete;
var rgcpHtmlSoftDeleteRestore = function rgcpHtmlSoftDeleteRestore(data) {
  return {
    type: _rgcpHtml.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft deleted list.
 */
exports.rgcpHtmlSoftDeleteRestore = rgcpHtmlSoftDeleteRestore;
var rgcpHtmlSoftDeletedList = function rgcpHtmlSoftDeletedList(data) {
  return {
    type: _rgcpHtml.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete.
 */
exports.rgcpHtmlSoftDeletedList = rgcpHtmlSoftDeletedList;
var rgcpHtmlBulkSoftDelete = function rgcpHtmlBulkSoftDelete(data) {
  return {
    type: _rgcpHtml.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore.
 */
exports.rgcpHtmlBulkSoftDelete = rgcpHtmlBulkSoftDelete;
var rgcpHtmlBulkRestore = function rgcpHtmlBulkRestore(data) {
  return {
    type: _rgcpHtml.actionTypes.BULK_RESTORE,
    payload: data
  };
};

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard delete.
 */
exports.rgcpHtmlBulkRestore = rgcpHtmlBulkRestore;
var rgcpHtmlBulkHardDelete = function rgcpHtmlBulkHardDelete(data) {
  return {
    type: _rgcpHtml.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};
exports.rgcpHtmlBulkHardDelete = rgcpHtmlBulkHardDelete;